import { createAction } from '@saucelabs/sl-util-redux';

import types from './types';

const injectImageRequest = createAction(types.MOBILE_DEVICE_INJECT_IMAGE.REQUEST);
const injectImageSuccess = createAction(types.MOBILE_DEVICE_INJECT_IMAGE.SUCCESS);
const injectImageFailure = createAction(types.MOBILE_DEVICE_INJECT_IMAGE.FAILURE);

export default {
  injectImageRequest,
  injectImageSuccess,
  injectImageFailure,
};
